import { Suspense, lazy } from "react";
import { Navigate } from "react-router-dom";

import MainLayout from "../layouts/main";
import SCDashboardLayout from "../layouts/dashboard/toOrderSC";
import LogoOnlyLayout from "../layouts/LogoOnlyLayout";

import LoadingScreen from "../components/LoadingScreen";
import { Company } from "redux/slices/auth";
import { PATH_LEVEL } from "utils/dataCenter";

const Loadable = (Component: React.ElementType) => (props: any) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks

  return (
    <Suspense
      fallback={
        null
        // <LoadingScreen
        //   sx={{
        //     ...(!isDashboard && {
        //       top: 80,
        //       left: 0,
        //       width: 1,
        //       zIndex: 9999,
        //       position: "fixed",
        //     }),
        //   }}
        // />
      }
    >
      <Component {...props} />
    </Suspense>
  );
};

// ----------------본사 시작

// home
const SCHomeOrderAnalytics = Loadable(
  lazy(() => import("../pages/dashboard/toOrderSC/Home/OrderAnalytics"))
);
const SCHomeSalesAnalytics = Loadable(
  lazy(() => import("../pages/dashboard/toOrderSC/Home/SalesAnalytics"))
);
const SCHomeSellsAnalytics = Loadable(
  lazy(() => import("../pages/dashboard/toOrderSC/Home/SellsAnalytics"))
);
const SCHomeSellsDetailAnalytics = Loadable(
  lazy(() => import("../pages/dashboard/toOrderSC/Home/SellsDetailAnalytics"))
);
// const SCHomeMapAnalytics = Loadable(
//   lazy(() => import("../pages/dashboard/toOrderSC/Home/MapAnalytics"))
// );
const MapAnalytics = Loadable(
  lazy(() => import("../pages/dashboard/toOrderSC/Home/MapAnalytics"))
);

// store
const SCStoreOrderAnalytics = Loadable(
  lazy(() => import("../pages/dashboard/toOrderSC/Store/OrdersAnalytics"))
);
const SCStoreSalesAnalytics = Loadable(
  lazy(() => import("../pages/dashboard/toOrderSC/Store/SalesAnalytics"))
);
const SCStoreSellsAnalytics = Loadable(
  lazy(() => import("../pages/dashboard/toOrderSC/Store/SellsAnalytics"))
);
const SCStoreSellsDetailAnalytics = Loadable(
  lazy(() => import("../pages/dashboard/toOrderSC/Store/SellsDetailAnalytics"))
);

const SCStoreReport = Loadable(
  lazy(() => import("../pages/dashboard/toOrderSC/Report/ReportPage"))
);

const SCNoticeBoard = Loadable(
  lazy(() => import("../pages/dashboard/toOrderSC/Notice/NoticePage"))
);

const SCNoticeGroup = Loadable(
  lazy(() => import("../pages/dashboard/toOrderSC/Notice/NoticeEdit"))
);

// ----------------본사 끝
// Main
const LandingPage = Loadable(lazy(() => import("../pages/LandingPage")));
const ComingSoon = Loadable(lazy(() => import("../pages/ComingSoon")));
const Maintenance = Loadable(lazy(() => import("../pages/Maintenance")));
const Page500 = Loadable(lazy(() => import("../pages/Page500")));
const NotFound = Loadable(lazy(() => import("../pages/Page404")));

export const DEFAULT_PATH = [
  {
    path: "*",
    element: <LogoOnlyLayout />,
    children: [
      { path: "coming-soon", element: <ComingSoon /> },
      { path: "maintenance", element: <Maintenance /> },
      { path: "500", element: <Page500 /> },
      { path: "404", element: <NotFound /> },
      { path: "*", element: <Navigate to="/404" replace /> },
    ],
  },
  {
    path: "/",
    element: <MainLayout />,
    children: [
      {
        path: "/",
        element: <Navigate to="/dashboard/sc_home/sc_salesanalytics" replace />,
      },
    ],
  },
  { path: "*", element: <Navigate to="/404" replace /> },
];

export const getHeadRoutes = (company: Company) => {
  const headPath: any = {
    path: "/",
    element: <SCDashboardLayout />,
    children: [],
  };
  const { PLUG_IN_NB, COMPANY_AUTH, PLUG_IN_MA } = company;
  if (PLUG_IN_NB) {
    headPath.children.push({
      path: "/",
      element: <Navigate to="/sc_board/sc_notice" replace />,
    });
    headPath.children.push({
      path: "sc_board",
      children: [
        { path: "sc_notice", element: <SCNoticeBoard /> },
        { path: "sc_group", element: <SCNoticeGroup /> },
      ],
    });
  } else {
    headPath.children.push({
      path: "/",
      element: <Navigate to="/sc_home/sc_salesanalytics" replace />,
    });
  }
  switch (COMPANY_AUTH?.toString()) {
    case PATH_LEVEL.BASIC:
    case PATH_LEVEL.STANDARD:
    case PATH_LEVEL.PREMIUM:
      if (PLUG_IN_MA) {
        headPath.children = [
          ...headPath.children,
          {
            path: "sc_home",
            children: [
              { path: "sc_salesanalytics", element: <SCHomeSalesAnalytics /> },
              { path: "sc_orderanalytics", element: <SCHomeOrderAnalytics /> },
              { path: "sc_sellsanalytics", element: <SCHomeSellsAnalytics /> },
              {
                path: "sc_sellsdetailanalytics",
                element: <SCHomeSellsDetailAnalytics />,
              },

              // { path: "sc_mapanalytics", element: <SCHomeMapAnalytics /> },
              { path: "sc_mapanalytics", element: <MapAnalytics /> },
            ],
          },
          {
            path: "sc_store",
            children: [
              { path: "sc_salesanalytics", element: <SCStoreSalesAnalytics /> },
              { path: "sc_orderanalytics", element: <SCStoreOrderAnalytics /> },
              { path: "sc_sellsanalytics", element: <SCStoreSellsAnalytics /> },
              {
                path: "sc_sellsdetailanalytics",
                element: <SCStoreSellsDetailAnalytics />,
              },
            ],
          },
          {
            path: "sc_report",
            element: <SCStoreReport />,
          },
        ];
      } else {
        headPath.children = [
          ...headPath.children,
          {
            path: "sc_home",
            children: [
              { path: "sc_salesanalytics", element: <SCHomeSalesAnalytics /> },
              { path: "sc_orderanalytics", element: <SCHomeOrderAnalytics /> },
              { path: "sc_sellsanalytics", element: <SCHomeSellsAnalytics /> },
              {
                path: "sc_sellsdetailanalytics",
                element: <SCHomeSellsDetailAnalytics />,
              },
            ],
          },
          {
            path: "sc_store",
            children: [
              { path: "sc_salesanalytics", element: <SCStoreSalesAnalytics /> },
              { path: "sc_orderanalytics", element: <SCStoreOrderAnalytics /> },
              { path: "sc_sellsanalytics", element: <SCStoreSellsAnalytics /> },
              {
                path: "sc_sellsdetailanalytics",
                element: <SCStoreSellsDetailAnalytics />,
              },
            ],
          },
          {
            path: "sc_report",
            element: <SCStoreReport />,
          },
        ];
      }

      break;
    default:
      if (PLUG_IN_MA) {
        headPath.children = [
          ...headPath.children,
          {
            path: "sc_home",
            children: [
              { path: "sc_salesanalytics", element: <SCHomeSalesAnalytics /> },
              { path: "sc_sellsanalytics", element: <SCHomeSellsAnalytics /> },
              {
                path: "sc_sellsdetailanalytics",
                element: <SCHomeSellsDetailAnalytics />,
              },
              // { path: "sc_mapanalytics", element: <SCHomeMapAnalytics /> },
              { path: "sc_mapanalytics", element: <MapAnalytics /> },
            ],
          },
          {
            path: "sc_store",
            children: [
              { path: "sc_salesanalytics", element: <SCStoreSalesAnalytics /> },
              { path: "sc_sellsanalytics", element: <SCStoreSellsAnalytics /> },
              {
                path: "sc_sellsdetailanalytics",
                element: <SCStoreSellsDetailAnalytics />,
              },
            ],
          },
          {
            path: "sc_report",
            element: <SCStoreReport />,
          },
        ];
      } else {
        headPath.children = [
          ...headPath.children,
          {
            path: "sc_home",
            children: [
              { path: "sc_salesanalytics", element: <SCHomeSalesAnalytics /> },
              { path: "sc_sellsanalytics", element: <SCHomeSellsAnalytics /> },
              {
                path: "sc_sellsdetailanalytics",
                element: <SCHomeSellsDetailAnalytics />,
              },
            ],
          },
          {
            path: "sc_store",
            children: [
              { path: "sc_salesanalytics", element: <SCStoreSalesAnalytics /> },
              { path: "sc_sellsanalytics", element: <SCStoreSellsAnalytics /> },
              {
                path: "sc_sellsdetailanalytics",
                element: <SCStoreSellsDetailAnalytics />,
              },
            ],
          },
          {
            path: "sc_report",
            element: <SCStoreReport />,
          },
        ];
      }

      break;
  }
  return [headPath, ...DEFAULT_PATH];
};
